<template>
  <div class="grid grid-cols-2 items-center gap-4">
    <InfuseInput
      v-model="maxElectricPower"
      :disabled="disabled"
      :max="max"
      :min="min"
      :required="required"
      :size="size"
      :step="requireValidStep ? step : 'any'"
      type="number"
      @update:model-value="emit('update:modelValue', $event)"
    />

    <input
      :id="`slider-slide-${labelId}`"
      v-model="maxElectricPower"
      :class="[size === 'xs' || size === 'small' ? 'range-sm' : '', size === 'large' ? 'range-lg' : '']"
      :disabled="disabled"
      :max="max"
      :min="min"
      :step="step"
      type="range"
      class="h-2 w-full cursor-pointer appearance-none rounded-lg bg-secondary-100 accent-primary-500 dark:bg-secondary-700"
      @update:model-value="emit('update:modelValue', Number.parseFloat($event))"
    />
  </div>
</template>

<script lang="ts" setup>
import { inject, ref, watch } from 'vue';
import { FieldLabelIdInjectionKey } from './InfuseFieldInjection';
import InfuseInput from './InfuseInput.vue';

interface Props {
  disabled?: boolean;
  max: number;
  min: number;
  modelValue: number;
  required?: boolean;
  size?: 'xs' | 'small' | 'medium' | 'large';
  step?: number;
  requireValidStep?: boolean;
  unit?: string;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  modelValue: NaN,
  required: false,
  size: 'medium',
  step: 1,
  requireValidStep: true,
  unit: ''
});

const emit = defineEmits(['update:modelValue']);

const labelId = inject(FieldLabelIdInjectionKey, null);

const maxElectricPower = ref<number>(0);

watch(props, (mv: Props) => {
  maxElectricPower.value = mv.modelValue || 0;
});
</script>
